<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="justify-center">ELIMINAR REGISTRO</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="text-center">
        <v-row>
          <v-col cols="12">
            <v-alert type="error" v-model="alertError" dismissible>
              <ul v-for="(errors, index) in listErrors" :key="index">
                <li v-text="errors[0]"></li>
              </ul>
            </v-alert>
          </v-col>

          <v-col cols="12">
            <p class="subtitle-1">
              ¿Está seguro que desea eliminar el registro
              <strong>{{ registro.title }}</strong>?
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          @click="eliminar()"
          :loading="processForm"
          color="error"
          large
          class="mr-2"
        >
          <v-icon left large>mdi-delete</v-icon> ELIMINAR
        </v-btn>
        <v-btn
          @click="$emit('cerrar')"
          :disabled="processForm"
          color="primary"
          large
        >
          <v-icon left large>mdi-close</v-icon> CANCELAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    registro: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dialog: true,
      processForm: false,
      listErrors: [],
      alertError: false,
    };
  },

  methods: {
    eliminar() {
      this.processForm = true;
      this.alertError = false;
      this.listErrors = [];

      this.axios
        .delete(`api/panel/page-data-catalog/${this.registro.id}`)
        .then(() => {
          this.$emit('eliminado');
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.listErrors = error.response.data.errors;
            this.alertError = true;
          }
        })
        .finally(() => {
          this.processForm = false;
        });
    },
  },
};
</script>